import React, { useMemo } from "react";

import { Col, Row } from "antd";
import get from "lodash/get";
import moment from "moment/min/moment-with-locales.min";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Button from "shared/components/Button";
import HtmlViewer from "shared/components/HtmlViewer";
import LabeledItem from "shared/components/LabeledItem";
import Space from "shared/components/Space";
import Pin from "shared/components/SVG/Pin";
import Time from "shared/components/SVG/Time";
import TabBar from "shared/components/TabBar";
import { NAME_SPACES } from "shared/locals/constants";
import { COLORS } from "shared/style/colors";
import { PATHS } from "utils/constants";
import { DOC_TYPES, ACTIONS_KEY } from "utils/constants";

import "./styles.scss";

const Products = ({ data, folderNum, activeAction }) => {
  const {
    productDesc,
    productBrand,
    productRef,
    creationDate,
    statusDesc,
    interventionType,
    productPhoto,
    statusColor,
    statusComment,
    warrantyDesc,
    extra,
  } = data;
  const documentation = useMemo(
    () => get(extra, "workflow.documentation"),
    [extra],
  );
  const { t } = useTranslation(NAME_SPACES.HOME);
  const ITEMS = t("TABS", { returnObjects: true });
  const items = [
    {
      key: ACTIONS_KEY.ADVANCEMENT,
      text: ITEMS.ADVANCEMENT,
      icon: <Time color={COLORS.CHRYSOPRASE_DARKER} />,
      link: PATHS.FILE.ACTIONS.replace(":action", "advancement").replace(
        ":id",
        folderNum,
      ),
    },
    /*  {
      key: ACTIONS_KEY.DETAILS,
      text: ITEMS.DETAILS,
      icon: <Tool color={COLORS.CHRYSOPRASE_DARKER} />,
      link: PATHS.FILE.ACTIONS.replace(":action", "details").replace(
        ":id",
        folderNum,
      ),
    },
    {
      key: ACTIONS_KEY.DOCUMENTS,
      text: ITEMS.DOCUMENTS,
      icon: <Files color={COLORS.CHRYSOPRASE_DARKER} />,
    },
    {
      key: ACTIONS_KEY.HISTORY,
      text: ITEMS.HISTORY,
      icon: <Historic color={COLORS.CHRYSOPRASE_DARKER} />,
    },
    {
      key: ACTIONS_KEY.ADDRESS,
      text: ITEMS.MESSAGES,
      icon: <Envelope color={COLORS.CHRYSOPRASE_DARKER} />,
    }, */
    {
      key: ACTIONS_KEY.ADDRESS,
      text: ITEMS.ADDRESS,
      icon: <Pin color={COLORS.CHRYSOPRASE_DARKER} />,
      link: PATHS.FILE.ACTIONS.replace(":action", "address").replace(
        ":id",
        folderNum,
      ),
    },
  ];

  const activeIndex = useMemo(
    () => items.findIndex(({ key }) => key === activeAction),
    [activeAction],
  );
  if (statusComment) {
    // ignore 'statusComment'
  }
  return (
    <div
      className={"page-card"}
      style={{ backgroundColor: `${statusColor}33` }}>
      <Row gutter={10}>
        <Col sm={12}>
          <div className={"product-details"}>
            {productPhoto && (
              <img
                src={productPhoto}
                alt=""
                onError={(event) => (event.target.style.display = "none")}
              />
            )}
            <div>
              <p>{productBrand}</p>
              <p>{productDesc}</p>
              {productRef !== productDesc && <p>{productRef}</p>}
            </div>
          </div>
        </Col>
        <Col sm={6}>
          <LabeledItem label={t("CREATED_DATE")}>
            <p className={"label-value"}>
              {moment(creationDate, "DD/MM/YYYY").format("DD.MM.YY")}
            </p>
          </LabeledItem>
          <Space h={12} />
          <p className={"label-value"}>{statusDesc}</p>
        </Col>
        <Col sm={6}>
          <LabeledItem label={t("INTERVENTION")}>
            <p className={"label-value"}>{warrantyDesc}</p>
            <p className={"label-value"}>{interventionType}</p>
          </LabeledItem>
          <Space h={12} />
          {documentation &&
            documentation.url &&
            (documentation.docType === DOC_TYPES.PDF ? (
              <Button
                text={"PDF"}
                custom="button-pdf"
                variant="BORDERED"
                onClick={() => window.open(documentation.url)}
              />
            ) : documentation.docType === DOC_TYPES.HTML ? (
              <div className={"documentation"}>
                <HtmlViewer url={documentation.url} />
              </div>
            ) : null)}
        </Col>
      </Row>
      <Space h={24} />
      <TabBar items={items} selectedItemIndex={activeIndex} />
    </div>
  );
};

Products.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      productDesc: PropTypes.string.isRequired,
      creationDate: PropTypes.string.isRequired,
      statusDesc: PropTypes.string.isRequired,
      interventionType: PropTypes.string.isRequired,
      productPhoto: PropTypes.string.isRequired,
      productBrand: PropTypes.string,
      productRef: PropTypes.string,
      statusComment: PropTypes.string,
      warrantyDesc: PropTypes.string,
      statusColor: PropTypes.string,
      extra: PropTypes.shape({
        workflow: PropTypes.object,
      }),
    }),
  ).isRequired,
  folderNum: PropTypes.string.isRequired,
  activeAction: PropTypes.string.isRequired,
};

export default Products;
